import React from "react";
import { RouteItem } from "./route-item";
import { Link } from "@reach/router";
import { Text } from "@chakra-ui/react";

export const Acknowledgment = () => (
  <RouteItem title="Acknowledgment">
    <Text>
      Application development is implemented by Koffi Anderson Koffi, a student
      at the University of Idaho studying computer science and electrical
      engineering.
    </Text>
  </RouteItem>
);
